import { AlienPatron, AlienStudentInteraction } from "./AlienPatron";
import { PhaserButtonConfig } from "src/games/shared/Button";
import { PhaserModalConfig } from "src/games/shared/Modal";
import { TiledGameObject } from "src/games/shared/phaserHelpers/HandyTypes";
import { Color } from "src/games/shared/ColorValue";

/**
 * Helpers
 */
export class Utils {
    // Planet E Color
    public static E_COLOR = Color.PLANET_COLORS.get("E");

    public static getButtonConfig(): PhaserButtonConfig {
        var config = new PhaserButtonConfig();
        config.backgroundColor = this.E_COLOR;
        return config;
    }

    public static getModalConfig(title: string, buttonWidth: number): PhaserModalConfig {
        var config = new PhaserModalConfig();
        config.title = title;
        config.buttonWidth = buttonWidth;
        config.buttonConfig = this.getButtonConfig();

        return config;
    }

    public static createPatronImage(scene: Phaser.Scene, ob: TiledGameObject, assetKey: string): Phaser.GameObjects.Image {
        var patronImage = scene.add.image(ob.x, ob.y, assetKey);
        patronImage.setOrigin(0);
        patronImage.setDisplaySize(ob.width, ob.height);
        patronImage.name = "patron";
        return patronImage;
    }

    public static createDialog(scene: Phaser.Scene, ob: TiledGameObject, text: string): Phaser.GameObjects.Text {
        var padding = 30;
        var textStyle = { fontSize: 22, color: "#F8E71C", fontFamily: 'Roboto Mono, Arial', padding: padding };
        var textObject = scene.add.text(ob.x, ob.y, text, textStyle);
        textObject.setOrigin(0);
        textObject.setWordWrapWidth(ob.width - 2 * padding, true);
        textObject.setDepth(10);
        textObject.name = "patronText";

        // Background for the dialog that spans across the scene
        var outline = scene.add.image(ob.x - 5, ob.y - 5, "pixel");
        outline.setOrigin(0);
        outline.setTint(this.E_COLOR);
        outline.setDisplaySize(ob.width + 10, ob.height + 10);

        var background = scene.add.image(ob.x, ob.y, "pixel");
        background.setOrigin(0);
        background.setDepth(0);
        background.setDisplaySize(ob.width, ob.height);
        background.setTint(0x000000);

        return textObject;
    }

    /**
     * Shuffle the responses so they're not in the same order every time
     * https://stackoverflow.com/questions/6274339/how-can-i-shuffle-an-array
     */
    public static scrambleResponses(patron: AlienPatron): void {
        patron.dialog.interactions.forEach((interaction: AlienStudentInteraction) => {
            var j, x, i;
            var responses = interaction.responses;
            for (i = responses.length - 1; i > 0; i--) {
                j = Math.floor(Math.random() * (i + 1));
                x = responses[i];
                responses[i] = responses[j];
                responses[j] = x;
            }
        });
    }

}



// WEBPACK FOOTER //
// ./src/games/HotelAuroraGame/objects/Utils.ts